"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var apps_shared_1 = require("@l2p/apps-shared");
var navigation_1 = require("next/navigation");
var swr_hooks_1 = require("@l2p/swr-hooks");
var LinkWrapper = function (props) {
    var WrappedComponent = props.WrappedComponent, slug = props.slug, openInfoModal = props.openInfoModal;
    var breakPoints = (0, apps_shared_1.useBreakpoint)();
    var isSignedIn = (0, swr_hooks_1.useIsAuthorized)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var push = (0, navigation_1.useRouter)().push;
    var handleClickOnGame = (0, react_1.useCallback)(function (fun) {
        if (fun === void 0) { fun = false; }
        if (isSignedIn) {
            push("/game/".concat(slug).concat(fun ? '?demo=true' : ''));
        }
        else {
            openSignUp();
        }
    }, [slug, isSignedIn, openSignUp, push]);
    if (!breakPoints.mobile && !breakPoints.tablet)
        return (react_1.default.createElement("span", { onClick: handleClickOnGame },
            react_1.default.createElement(WrappedComponent, null)));
    return react_1.default.createElement(WrappedComponent, { onClick: openInfoModal });
};
exports.default = LinkWrapper;
